   var swiper = new Swiper(".review-slider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
     breakpoints: {
        1300: {
          slidesPerView: 4.30,
          spaceBetween: 30,
        },
        1080: {
          slidesPerView: 3.30,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2.30,
          spaceBetween: 15,
        },
        0: {
          slidesPerView: 1.30,
          spaceBetween: 10,
        },
      },
    });